import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fileUrl, formatPrice } from "@/lib/api";
import WatermarkOverlay from "@/components/site/WatermarkOverlay";

export default function ProductCard({ product, categoryName }) {
  const img = product.images?.[0];
  const priced = (product.variants || []).flatMap((v) => (v.values || []).map((x) => x.price)).filter(Boolean);
  const nums = priced.map((p) => parseFloat(String(p).replace(",", ".").replace(/[^\d.]/g, ""))).filter((n) => !isNaN(n)).sort((a, b) => a - b);
  const hasVariantPrices = nums.length > 0;
  const basePrice = product.price || (hasVariantPrices ? nums[0].toFixed(2) : null);
  const displayPrice = !basePrice ? "Цена по запросу" : (hasVariantPrices ? `от ${formatPrice(basePrice)}` : formatPrice(basePrice));
  return (
    <Link
      to={`/product/${product.slug || product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group bg-white rounded-xl border border-slate-100 overflow-hidden hover:-translate-y-1 hover:shadow-xl hover:shadow-slate-200/60 transition-all duration-300 flex flex-col"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        {img ? (
          <img src={fileUrl(img)} alt={product.title} loading="lazy" decoding="async" className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ${product.in_stock === false ? "grayscale-[60%] opacity-80" : ""}`} />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-300">нет фото</div>
        )}
        {img && product.watermark && <WatermarkOverlay />}
        {product.in_stock === false && (
          <span className="absolute top-3 right-3 bg-slate-700/85 backdrop-blur-sm text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md" data-testid={`out-of-stock-badge-${product.id}`}>Нет в наличии</span>
        )}
        {product.featured && (
          <span className="absolute top-3 left-3 bg-[#0E7C86] text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md">Хит</span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        {categoryName && <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#0E7C86] mb-1.5">{categoryName}</span>}
        <h3 className="font-display font-semibold text-[#0F1720] leading-snug group-hover:text-[#E85D2A] transition-colors">{product.title}</h3>
        <p className="text-sm text-slate-500 mt-2 line-clamp-2 flex-1">{product.short_description}</p>
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-100">
          <span className="font-display font-bold text-[#0F1720]" data-testid={`product-price-${product.id}`}>{displayPrice}</span>
          <span className="w-8 h-8 rounded-full bg-slate-100 group-hover:bg-[#E85D2A] group-hover:text-white flex items-center justify-center transition-colors">
            <ArrowUpRight size={16} />
          </span>
        </div>
      </div>
    </Link>
  );
}
